<div class="modal-header">
    <h4 class="modal-title">
        Kalibrasyon Güncelle - {{calibration.calibrationNo}} / Teslimat Kodu ({{calibration.deliveryDevice.deliveryCode}})
    </h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body calibration-modal">
    <div class="row">
        <div class="col-12">
            <h4 class="card-title">Firma Bilgileri</h4>
            <div class="card shadow-none bg-transparent border-success">
                <div class="card-body row">
                    <div class="col-xl-8 col-md-12 col-sm-12">
                        {{calibration.deliveryDevice?.company?.companyName }}</div>
                    <div class="col-xl-1-5 col-md-6 col-sm-12">{{ calibration.deliveryDevice?.no }}</div>
                    <div class="col-xl-1-5 col-md-6 col-sm-12">{{calibration.deliveryDevice?.company?.phoneNumber}}
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-4 col-md-6 col-sm-12">
            <h4 class="card-title">Cihaz Bilgileri</h4>
            <div class="card shadow-none bg-transparent border-info" style="height: 220px;">
                <div class="card-body">
                    <p><strong>Cihaz Adı:</strong> {{calibration?.deliveryDevice?.deviceName}}</p>
                    <div class="row">
                        <div class="col-xl-6 col-md-6 col-sm-12">
                            <div class="d-flex justify-content-between mt-50">
                                <strong>Seri No:</strong>
                                <span>{{ calibration?.deliveryDevice?.seriNo }}</span>
                            </div>
                            <div class="d-flex justify-content-between mt-50">
                                <strong>Tür:</strong>
                                <span>{{ calibration?.deliveryDevice?.kindTypeName }}</span>
                            </div>
                            <div class="d-flex justify-content-between mt-50">
                                <strong>Yer:</strong>
                                <span>{{ calibration?.deliveryDevice?.place }}</span>
                            </div>
                            <div class="d-flex justify-content-between mt-50">
                                <strong>Çözünürlük:</strong>
                                <span>{{ calibration?.deliveryDevice?.resolution }}</span>
                            </div>
                        </div>
                        <div class="col-xl-6 col-md-6 col-sm-12">
                            <div class="d-flex justify-content-between mt-50">
                                <strong>Marka:</strong>
                                <span>{{ calibration?.deliveryDevice?.brandName }} - {{
                                    calibration?.deliveryDevice?.modelName
                                    }}</span>
                            </div>
                            <div class="d-flex justify-content-between mt-50">
                                <strong>Envanter No:</strong>
                                <span>{{ calibration?.deliveryDevice?.inventoryNumber }}</span>
                            </div>
                            <div class="d-flex justify-content-between mt-50">
                                <strong>Cih Kod:</strong>
                                <span>{{ calibration2?.deviceCode }}</span>
                            </div>
                            <div class="d-flex justify-content-between mt-50">
                                <strong>Referans Aralığı:</strong>
                                <span>
                                    {{ calibration2?.deviceReferenceMin }} {{calibration2?.deviceReferenceUnitType}}
                                    -
                                    {{ calibration2?.deviceReferenceMax }} {{calibration2?.deviceReferenceUnitType}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-xl-8 col-md-6 col-sm-12">
            <h4 class="card-title">Kalibrasyon Bilgileri</h4>
            <div class="card shadow-none bg-transparent border-warning">
                <div class="p-50">
                    <div class="row">
                        <div class="col-xl-2 col-md-6 col-sm-12"><strong>Sert Bas. Firma:</strong></div>
                        <div class="col-xl-12 col-md-6 col-sm-12">
                            <input type="text" class="form-control" id="basicInput" readonly="true"
                                placeholder="Enter email" [value]="calibration.deliveryDevice?.certficateCompany" />
                        </div>
                    </div>

                    <!-- İkinci satır -->
                    <div class="row mt-1">
                        <div class="col-xl-auto col-md-6 col-sm-12"><strong>Ortam Şartı</strong></div>
                        <div class="col-xl-3 col-md-6 col-sm-12">
                            <ng-select [items]="environmentalContent" [(ngModel)]="enviromentalContentId"
                                placeholder="Çevre şartı seç" bindValue="id" bindLabel="typeName"
                                #environmental="ngModel" required>
                                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                    <h6 class="mb-1">{{ item.deviceName }}</h6>
                                    <div class="card-subtitle mb-2 text-muted">
                                        <p *ngFor="let environmental of item.enviromentalContent">
                                            {{ environmental.name }}, {{ environmental.start }}, {{
                                            environmental.end }}
                                        </p>
                                        {{ item.typeName }}
                                    </div>
                                </ng-template>

                            </ng-select>
                            <div class="text-danger mt-1" *ngIf="environmental.invalid && environmental.touched">
                                Çevre şartı seçimi zorunludur.
                            </div>
                        </div>

                        <div class="col-xl-1-5 col-md-6 col-sm-12"><strong>Kal. Yapan</strong></div>
                        <div class="col-xl-2 col-md-6 col-sm-12">
                            <ng-select [items]="persons" [(ngModel)]="selectedPersonId"
                                placeholder="Kalibrasyon Yapanı Seç" bindLabel="fullName" bindValue="id"
                                #person="ngModel" required>
                            </ng-select>
                            <div class="text-danger mt-1" *ngIf="person.invalid && person.touched">
                                Kalibrasyon yapan kişi seçimi zorunludur.
                            </div>
                        </div>

                        <div class="col-xl-auto col-md-6 col-sm-12"><strong>Akra. Kuruluşu</strong></div>
                        <div class="col-xl-2 col-md-6 col-sm-12">
                            <ng-select [items]="akradetionOrganization" [(ngModel)]="selectedAcradtionOrganizationId"
                                placeholder="Akradite Kurumunu Seç" bindLabel="name" bindValue="id"
                                #akreditation="ngModel" required>
                            </ng-select>
                            <div class="text-danger mt-1" *ngIf="akreditation.invalid && akreditation.touched">
                                Akredite kuruluşu seçimi zorunludur.
                            </div>
                        </div>

                    </div>

                    <!-- Üçüncü satır -->
                    <div class="row mt-1">
                        <div class="col-xl-auto col-md-6 col-sm-12"><strong>Kal. Method</strong></div>
                        <div class="col-xl-3 col-md-6 col-sm-12">
                            <ng-select [items]="kindProcedures" [(ngModel)]="selectProcedureId"
                                placeholder="Kalibrasyon methodu seç" bindValue="id" bindLabel="name"
                                #procedure="ngModel" required>
                            </ng-select>
                            <div class="text-danger mt-1" *ngIf="procedure.invalid && procedure.touched">
                                Kalibrasyon methodu seçimi zorunludur.
                            </div>
                        </div>

                        <div class="col-xl-1-5 col-md-6 col-sm-12"><strong>Kal. Tarihi</strong></div>
                        <div class="col-xl-2 col-md-6 col-sm-12">
                            <ng2-flatpickr [config]="dateTimeStartOptions" [setDate]="date"
                                [(ngModel)]="date"></ng2-flatpickr>
                        </div>

                        <div class="col-xl-auto col-md-6 col-sm-12"><strong>Kal. Yeri</strong></div>
                        <div class="col-xl-1 col-md-6 col-sm-12">
                            <div class="custom-control custom-radio">
                                <!-- <input type="checkbox" class="custom-control-input" id="customCheck1"
                                                    [(ngModel)]="isPlace" />
                                                <label class="custom-control-label" for="customCheck1"></label> -->

                                <input type="radio" id="customRadio1" name="customRadio" class="custom-control-input"
                                    [checked]="isPlace" (change)="onPlaceChange(true)" />
                                <label class="custom-control-label" for="customRadio1">Yerinde</label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input type="radio" id="customRadio2" name="customRadio" class="custom-control-input"
                                    [checked]="!isPlace" (change)="onPlaceChange(false)" />
                                <label class="custom-control-label" for="customRadio2">Laboratuvarda</label>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-1">
                        <div class="col-xl-auto col-md-6 col-sm-12"><strong>Kal. Adresi</strong></div>
                        <div class="col-xl-6 col-md-6 col-sm-12">
                            <input type="text" class="form-control" [(ngModel)]="calibrationAddress">
                        </div>

                        <div class="col-xl-1-5 col-md-6 col-sm-12" *ngIf="!isPlace">
                            Kabul Tarihi
                        </div>
                        <div class="col-xl-2 col-md-6 col-sm-12" *ngIf="!isPlace">
                            <ng2-flatpickr [config]="dateTimeStartOptions" [setDate]="date2"
                                [(ngModel)]="date2"></ng2-flatpickr>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-xl-5 col-md-12 col-sm-12">
            <h4 class="card-title">Referans Cihaz Bilgileri</h4>
            <div class="card shadow-none bg-transparent border-warning">
                <div class="form-group col-xl-12 col-md-12 col-sm-12">
                    <label>Referans Cihazları Seç</label>
                    <ng-select [items]="refereceDevices" (change)="onDeviceSelect($event)" [(ngModel)]="selectedDevice"
                        placeholder="Referans Cihaz Seç" bindLabel="seriNo" bindValue="id">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="d-flex justify-content-between align-items-center">
                                <h6 class="mb-1">{{ item.deviceName }}</h6>
                                <span class="badge" [ngClass]="{
                                                    'badge-success': item.isCalibrationValid,
                                                    'badge-danger': !item.isCalibrationValid
                                                  }">
                                    {{ item.isCalibrationValid ? 'Aktif' : 'Pasif' }}
                                </span>
                            </div>
                            <p class="text-muted mb-1">{{item.typeName}}</p>
                            <p class="card-subtitle text-muted">
                                {{ item.brandName }} / {{item.modelName}} - {{item.seriNo}} -
                                {{item.typeName}}
                            </p>
                            <p class="text-muted">{{item.referenceMin}} {{item.referenceUnitType}} -
                                {{item.referenceMax}} {{item.referenceUnitType}}</p>

                        </ng-template>
                    </ng-select>
                    <div class="text-danger mt-1" *ngIf="!selectedDevices || selectedDevices.length === 0">
                        En az bir referans cihaz seçmelisiniz.
                    </div>
                </div>
                <div class="table-responsive mt-1">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>Kod</th>
                                <th>Marka/Model</th>
                                <th>Serial No</th>
                                <th>Tür</th>
                                <th>#</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let device of selectedDevices">
                                <td>{{ device.code }}</td>
                                <td>{{ device.brandName }} / {{ device.modelName }}</td>
                                <td>{{ device.seriNo }}</td>
                                <td>{{ device.typeName }}</td>
                                <td>
                                    <button type="button" class="btn btn-icon btn-flat-danger" appDelete
                                        controller="CalibrationReferenceDevices" [id]="device.ReferenceDeviceId"
                                        (callback)="onReferenceDeviceDeleted(device.ReferenceDeviceId)" rippleEffect>
                                        <span [data-feather]="'trash'"></span></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-xl-7 col-md-12 col-sm-12">
            <h4 class="card-title">Sertfika Bilgileri</h4>
            <div class="card shadow-none bg-transparent border-warning">
                <form [formGroup]="certificateForm" (ngSubmit)="onSubmit()" class="mt-2">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-xl-3 col-md-6 col-sm-12" *ngIf="false">
                                <div class="form-group">
                                    <label for="disabledInput">Sertfika No</label>
                                    <input type="text" class="form-control" id="readonlyInput" readonly="readonly"
                                        formControlName="certificateNo" [value]="certificateNumber" />
                                </div>
                            </div>
                            <div class="col-xl-3 col-md-6 col-sm-12">
                                <div class="form-group">
                                    <label for="responsiblePerson">Sertfika No</label>
                                    <ng-select [items]="certificateReservations" bindLabel="reservedCertificateNo"
                                        bindValue="id" [placeholder]="certificateNumber"
                                        (change)="onReservationSelect($event)" (clear)="resetCertificateNumber()">
                                        <ng-template ng-header-tmp>
                                            <div class="d-flex justify-content-center">
                                                <button type="button" class="btn btn-flat-success"
                                                    (click)="addReservation()">
                                                    <span data-feather="plus"></span>
                                                    Rezerve Ekle
                                                </button>
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col-xl-3 col-md-6 col-sm-12">
                                <div class="form-group mb-2">
                                    <label for="personId">Onaylayan Personel</label>
                                    <ng-select [items]="calCompanyPerson" formControlName="personId"
                                        placeholder="Kalibrasyon Onaylayan Personel" bindLabel="fullName"
                                        bindValue="id">
                                    </ng-select>
                                    <div class="text-danger mt-1" *ngIf="certificateForm.get('personId')?.invalid">
                                        Onaylayan personel seçimi zorunludur.
                                    </div>
                                </div>
                            </div>

                            <div class="col-xl-3 col-md-6 col-sm-12">
                                <div class="form-group mb-2">
                                    <label for="startDate">Yayımlanma Tarihi</label>
                                    <ng2-flatpickr [config]="dateTimereviseEndOptions" formControlName="issueDate"
                                        [setDate]="certificateIssuedate"></ng2-flatpickr>
                                </div>
                            </div>

                            <div class="col-xl-3 col-md-6 col-sm-12">
                                <div class="form-group mb-2">
                                    <label for="startDate">Geçerlilik Tarihi</label>
                                    <ng2-flatpickr [config]="dateTimereviseStartOptions" formControlName="expiryDate"
                                        [setDate]="certificateExpiryDate"></ng2-flatpickr>
                                </div>
                            </div>

                            <div class="col-xl-12 col-md-12 col-sm-12 row ml-50">
                                <div class="col-auto form-group mb-2 custom-control custom-checkbox">
                                    <input type="checkbox" id="visualAndFunctional"
                                        formControlName="visualAndFunctional" class="custom-control-input">
                                    <label class="custom-control-label" for="visualAndFunctional">
                                        Görsel ve Fonksiyonel
                                        Kontrolü</label>
                                </div>
                                <div class="col-auto form-group mb-2 custom-control custom-checkbox">
                                    <input type="checkbox" id="isPrivateResiveNo" formControlName="isPrivateResiveNo"
                                        class="custom-control-input">
                                    <label class="custom-control-label" for="isPrivateResiveNo">Rev.
                                        No Sertf. Gözüksün</label>
                                </div>
                                <div class="col-auto form-group mb-2 custom-control custom-checkbox">
                                    <input type="checkbox" id="isPrivateResiveDescription"
                                        formControlName="isPrivateResiveDescription" class="custom-control-input">
                                    <label class="custom-control-label" for="isPrivateResiveDescription">Rev.
                                        Açıklaması Sertf.
                                        Gözüksün</label>
                                </div>
                            </div>


                            <div class="col-xl-9 col-md-6 col-sm-12">
                                <div class="form-group">
                                    <label for="reviseDescription">Revize Gerekçesi</label>
                                    <fieldset class="form-group">
                                        <textarea class="form-control" id="basicTextarea" rows="1"
                                            placeholder="revize açıklamasını yazınız"
                                            formControlName="reviseDescription"></textarea>
                                    </fieldset>
                                </div>
                            </div>

                            <div class="col-xl-3 col-md-6 col-sm-12">
                                <div class="form-group mb-2">
                                    <label for="startDate">Revize Tarihi</label>
                                    <ng2-flatpickr [config]="dateTimeReviseOptions" formControlName="reviseDate"
                                        [setDate]="certificateReviseDate"></ng2-flatpickr>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="col-xl-12 col-md-6 col-sm-12 row">
            <div class="col-xl-2 col-md-2 col-sm-12 mt-2">
                <button type="button" class="btn btn-outline-info w-100"
                    [disabled]="!selectMeasurementId || selectedDevices.length < 1" (click)="downloadSelectedFile()">
                    İndir
                </button>
            </div>

            <div class="col-xl-3 col-md-4 col-sm-12">
                <label>Ölçüm Dosyasını İndir</label>
                <ng-select [items]="measurementResults" [(ngModel)]="selectMeasurementId" placeholder="Ölçüm Sonucu"
                    bindValue="id" bindLabel="fileName">
                </ng-select>
            </div>

            <div class="col-xl-3 col-md-6 col-sm-12">
                <div class="form-group">
                    <label for="basicInputFile">Ölçüm Dosyasını Seç (Excel)</label>
                    <div class="custom-file">
                        <input type="file" accept=".xlsx, .xls, .xlsm" (change)="onFileSelected2($event)"
                            class="custom-file-input" id="customFile" />
                        <label class="custom-file-label" for="customFile">Choose
                            file</label>
                    </div>
                    <button *ngIf="pdfDoc" type="button" class="btn btn-sm btn-danger mt-2"
                        (click)="clearFile()">Dosyayı
                        Sil</button>
                </div>
            </div>

            <div class="col-xl-4 col-md-6 col-sm-12 mt-2">
                <button type="button" class="btn btn-info mr-1"
                    (click)="selectedFile != null ? convert() : isPdfDocDetail()">
                    {{selectedFile != null ? 'Ölçüm Sonuçlarını Gör' : 'Ölçüm Sonuçları'}}
                </button>

                <button type="button" class="btn btn-success" [disabled]="isSaveDisabled() || !certificateForm.valid"
                    (click)="saveData()">Kaydet
                </button>
            </div>
        </div>
    </div>

    <div class="col-12" *ngIf="pdfUrl" style="height:800px;">
        <iframe *ngIf="pdfUrl" [src]="pdfUrl" width="100%" height="800px" style="border:1px solid #ccc"></iframe>
    </div>